export const socialLinks = {
  FACEBOOK: 'https://www.facebook.com/Shipt',
  INSTAGRAM: 'https://www.instagram.com/shipt/',
  LINKEDIN: 'https://www.linkedin.com/company/shipt',
  YOUTUBE: 'https://www.youtube.com/channel/UCHEMMzUYWWaALsl6KDNCckA',
  PINTEREST: 'https://www.pinterest.com/shipt/',
  TWITTER: 'https://twitter.com/Shipt',
}
